<template>
  <v-modal
    @hide-modal="$emit('hide-modal')"
    size="md"
  >
    <template v-slot:title>
      <div v-if="researchItem">
        {{ $t('phrase.duplicate_item') }}
        <div class="badge badge-info" v-if="researchItem">
          {{ $t(RENDER_TYPES_DISPLAY[researchItem.render_type]) }}
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div v-if="researchItem">
        <form @submit.prevent="submit">
          <div class="mb-2">
            <v-text-input
              v-model="formData.title"
              label="word.title"
              :auto-focus="true"
              :auto-select="true"
              :required="true"
            />
          </div>

          <div class="d-flex justify-content-end">
            <v-button
              type="submit"
              icon="copy"
              size="sm"
              text="word.duplicate"
            />
          </div>
        </form>
      </div>
    </template>
  </v-modal>
</template>

<script>
import Modal from '@/common/components/Modal.vue';
import Button from '@/common/components/Button.vue';
import { duplicateResearchItem, fetchResearchItem } from '@/organisation/api';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { notify } from '@/common/utils/notify';
import { RENDER_TYPES_DISPLAY } from '@/organisation/constants';

export default {
  name: 'ItemDuplicateModal',
  components: {
    'v-button': Button,
    'v-modal': Modal,
    'v-text-input': TextInput,
  },
  props: {
    researchItemId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      RENDER_TYPES_DISPLAY,
      researchItem: null,
      formData: {
        title: '',
      },
    };
  },
  methods: {
    async fetchResearchItem() {
      const response = await fetchResearchItem(this.researchItemId);
      this.researchItem = response.data;
      this.formData.title = this.researchItem.title;
    },
    async submit() {
      const response = await duplicateResearchItem(this.researchItemId, this.formData);
      if (response.status === 201) {
        notify('phrase.item_duplicated', 'sentence.item_duplicated');
        this.$emit('updated');
        this.$emit('hide-modal');
      } else {
        this.errors = response.data;
      }
    },
  },
  created() {
    this.fetchResearchItem();
  },
};
</script>
